// import React from 'react'
// import contactBannerMobile from '../assets/images/contactBannerMobile.jpg'
// import contactBanner from '../assets/images/contactBanner.jpg'
// import { FaEnvelope } from "react-icons/fa";
// import { FaMobileScreenButton } from "react-icons/fa6";
// import { FaLocationDot } from "react-icons/fa6";
// import { Link } from 'react-router-dom';
// import Layout from './layout';

// const ContactUs = () => {
//     return (
//         <>
//         <Layout>
//             <div className="contact-us image-banner hero-banner color-light d-flex flex-column justify-center gap-30 d-gap-50 full-screen position-relative">
//                 <picture className="cover position-absolute top-0 start-0">
//                     <source media="(max-width:768px)" srcSet={contactBannerMobile} />
//                     <img className="cover" src={contactBanner} alt="" />
//                 </picture>
//                 <div className='contact-form-block'>
//                     <div className='container'>
//                         <div className='grid-blocks d-grid d-column-2 gap-100'>
//                             <div className='grid-block left-block'>
//                                 <div className='summary-block'>
//                                     <h1 className='fw-200 mb-30'>Contact us</h1>
//                                     <ul className='icon-list'>
//                                         <li><Link to='mailto:the@luminicos.com' className='d-flex gap-15'><FaEnvelope /> the@luminicos.com</Link></li>
//                                     </ul>
//                                 </div>
//                                 <div className='form-block d-pt-50'>
//                                     <form className="d-flex flex-column gap-20 d-gap-30">
//                                         <div className='form-field'>
//                                             <input type="text" placeholder="Name" className="w-100" />
//                                         </div>
//                                         <div className='form-field'>
//                                             <input type="email" placeholder="Email" className="w-100" />
//                                         </div>
//                                         <div className='form-field'>
//                                             <input type="tel" placeholder="Phone number" className="w-100" />
//                                         </div>
//                                         <div className='form-field'>
//                                             <textarea placeholder="Message" className="w-100"></textarea>
//                                         </div>
//                                         <div className='form-field text-right'>
//                                             <button type="submit" className="button border-bottom border-light pb-5 ps-10"> Send Now</button>
//                                         </div>

//                                     </form>
//                                 </div>
//                             </div>
//                             <div className='grid-block right-block d-flex flex-column justify-center'>
//                                 <div className='grid-blocks d-grid d-column-2 gap-40'>
//                                     <div className='grid-block left-block'>
//                                         <div className='button'>lima</div>
//                                         <ul className='icon-list pt-10 d-pt-20 d-grid gap-15'>
//                                             <li><Link to='mailto:the@luminicos.com' className='d-flex gap-15'><FaMobileScreenButton /> +51 1 748 1221</Link></li>
//                                             <li><Link to='mailto:the@luminicos.com' className='d-flex gap-15'><FaLocationDot className='location'/> Bolognesi 180, Miraflores, Lima, Perú.</Link></li>
//                                         </ul>
//                                     </div>
//                                     <div className='grid-block right-block'>
//                                         <div className='button'>Miami</div>
//                                         <ul className='icon-list pt-10 d-pt-20 d-grid gap-15'>
//                                             <li><Link to='mailto:the@luminicos.com' className='d-flex gap-15'><FaMobileScreenButton /> +51 1 748 1221</Link></li>
//                                             <li><Link to='mailto:the@luminicos.com' className='d-flex gap-15'><FaLocationDot className='location'/> 2125 Biscayne Blvd Suite 242 Miami, FL 33137 USA</Link></li>
//                                         </ul>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             </Layout>
//         </>
//     )
// }

// export default ContactUs





import React, { useState } from 'react';
import contactBannerMobile from '../assets/images/contactBannerMobile.jpg';
import contactBanner from '../assets/images/contactBanner.jpg';
import { FaEnvelope } from "react-icons/fa";
import { FaMobileScreenButton } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from './layout';
import config from '../config';
import contactContent from '../JSONData/contact.json';

const ContactUs = () => {
    const navigate = useNavigate();
    const { lang } = useParams();
    const content = (contactContent && contactContent[lang]) ? contactContent[lang] : contactContent.en;
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: '',
        phone: '',
        projectType: '',
        projectLocation: '',
        estimatedTimeline: '',
        hearAboutUs: '',
        newsletter: '',
        message: ''
    });

    const [statusMessage, setStatusMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            const response = await fetch(`${config.BASE_URL}/api/admin/send-email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            const result = await response.json();
            if (response.ok) {
                setStatusMessage('Email sent successfully!');
                // navigate('/');
                setTimeout(() => {
                    navigate('/');
                }, 5000);
            } else {
                setStatusMessage(`Error: ${result.message}`);
            }
        } catch (error) {
            console.error('Error sending email:', error);
            setStatusMessage('Failed to send email.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Layout>
                <div className="contact-us image-banner hero-banner color-light d-flex flex-column justify-center gap-30 d-gap-50 position-relative pt-120 d-pt-150 pb-80 d-pb-100">
                    <picture className="cover position-absolute top-0 start-0">
                        <source media="(max-width:768px)" srcSet={contactBannerMobile} />
                        <img className="cover" src={contactBanner} alt="" />
                    </picture>
                    <div className='contact-form-block'>
                        <div className='container'>
                            <div className='grid-blocks d-grid d-column-2 gap-50 d-gap-100'>
                                <div className='grid-block left-block'>
                                    <div className='summary-block mb-40 d-mb-0'>
                                        <h1 className='fw-200 mb-20 d-mb-30'>{content.heading}</h1>
                                        <ul className='icon-list'>
                                            <li><Link to='mailto:the@luminicos.com' className='d-flex gap-15'><FaEnvelope /> the@luminicos.com</Link></li>
                                        </ul>
                                    </div>
                                    <div className='form-block d-pt-50'>
                                        <form className="d-flex flex-column gap-20 d-gap-30" onSubmit={handleSubmit}>
                                            <div className='form-fields d-grid d-column-2 gap-20'>
                                                <div className='form-field'>
                                                    <input type="text" name="name" placeholder={content.placeholders.name} className="w-100" value={formData.name} onChange={handleChange} required />
                                                </div>
                                                <div className='form-field'>
                                                    <input type="email" name="email" placeholder={content.placeholders.email} className="w-100" value={formData.email} onChange={handleChange} required />
                                                </div>
                                            </div>
                                            <div className='form-fields d-grid d-column-2 gap-20'>
                                                <div className='form-field'>
                                                    <input type="text" name="company" placeholder={content.placeholders.company} className="w-100" value={formData.company} onChange={handleChange} />
                                                </div>
                                                <div className='form-field'>
                                                    <input type="tel" name="phone" placeholder={content.placeholders.phone} className="w-100" value={formData.phone} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className='form-fields d-grid d-column-2 gap-20'>
                                                <div className='form-field '>
                                                    <select name="projectType" value={formData.projectType} onChange={handleChange} className="w-100">
                                                        <option value="">{content.selects.projectType.label}</option>
                                                        <option value="Hospitality">{content.selects.projectType.options.hospitality}</option>
                                                        <option value="Commercial">{content.selects.projectType.options.commercial}</option>
                                                        <option value="Residential">{content.selects.projectType.options.residential}</option>
                                                        <option value="Community Spaces">{content.selects.projectType.options.community}</option>
                                                        <option value="Infrastructure">{content.selects.projectType.options.infrastructure}</option>
                                                        <option value="Other">{content.selects.projectType.options.other}</option>
                                                    </select>
                                                </div>
                                                <div className='form-field'>
                                                    <input type="text" name="projectLocation" placeholder={content.placeholders.projectLocation} className="w-100" value={formData.projectLocation} onChange={handleChange} />
                                                </div>
                                            </div>
                                            <div className='form-fields d-grid d-column-2 gap-20'>
                                                <div className='form-field'>
                                                    <select name="estimatedTimeline" value={formData.estimatedTimeline} onChange={handleChange} className="w-100">
                                                        <option value="">{content.selects.estimatedTimeline.label}</option>
                                                        <option value="Early Concept">{content.selects.estimatedTimeline.options.early}</option>
                                                        <option value="Design Development">{content.selects.estimatedTimeline.options.design}</option>
                                                        <option value="Ready to Start">{content.selects.estimatedTimeline.options.ready}</option>
                                                    </select>
                                                </div>
                                                <div className='form-field'>
                                                    <select name="hearAboutUs" value={formData.hearAboutUs} onChange={handleChange} className="w-100">
                                                        <option value="">{content.selects.hearAboutUs.label}</option>
                                                        <option value="Google Search">{content.selects.hearAboutUs.options.google}</option>
                                                        <option value="LinkedIn">{content.selects.hearAboutUs.options.linkedin}</option>
                                                        <option value="Instagram">{content.selects.hearAboutUs.options.instagram}</option>
                                                        <option value="YouTube">{content.selects.hearAboutUs.options.youtube}</option>
                                                        <option value="Referral from a Client or Partner">{content.selects.hearAboutUs.options.referral}</option>
                                                        <option value="Word of Mouth Event or Conference">{content.selects.hearAboutUs.options.wordOfMouth}</option>
                                                        <option value="Newsletter or Email Campaign">{content.selects.hearAboutUs.options.newsletter}</option>
                                                        <option value="Other">{content.selects.hearAboutUs.options.other}</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className='form-field'>
                                                <ul className='icon-list mb-10'>
                                                    <li>{content.newsletter.question}</li>
                                                </ul>
                                                <div className='form-field'>
                                                    <label className='d-flex align-center gap-10'>
                                                        <input type="radio" name="newsletter" value="yes" checked={formData.newsletter === 'yes'} onChange={handleChange} />
                                                        <span>{content.newsletter.yes}</span>
                                                    </label>
                                                </div>
                                                <div className='form-field'>
                                                    <label className='d-flex align-center gap-10'>
                                                        <input type="radio" name="newsletter" value="no" checked={formData.newsletter === 'no'} onChange={handleChange} />
                                                        <span>{content.newsletter.no}</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='form-field'>
                                                <textarea name="message" placeholder={content.placeholders.message} className="w-100" value={formData.message} onChange={handleChange} required></textarea>
                                            </div>
                                            <div className='form-field text-right'>
                                                <button type="submit" className="button border-bottom border-light pb-5 ps-10" disabled={isSubmitting}>{isSubmitting ? content.sending : content.sendNow}</button>
                                            </div>
                                        </form>
                                        {statusMessage && <p className="status-message">{statusMessage}</p>}
                                    </div>
                                </div>
                                <div className='grid-block right-block d-flex flex-column justify-center'>
                                    <div className='grid-blocks d-grid d-column-2 gap-40'>
                                        <div className='grid-block left-block'>
                                            <div className='button'>{content.offices.lima}</div>
                                            <ul className='icon-list pt-10 d-pt-20 d-grid gap-15'>
                                                <li><Link to='tel:+51 1 748 1221' className='d-flex gap-15'><FaMobileScreenButton /> +51 1 748 1221</Link></li>
                                                <li><Link to='mailto:lima@luminicos.com' className='d-flex gap-15'><FaEnvelope /> lima@luminicos.com</Link></li>
                                                <li><Link to='' className='d-flex gap-15'><FaLocationDot className='location' /> Bolognesi 180, Miraflores, Lima, Perú.</Link></li>
                                            </ul>
                                        </div>
                                        <div className='grid-block right-block'>
                                            <div className='button'>{content.offices.miami}</div>
                                            <ul className='icon-list pt-10 d-pt-20 d-grid gap-15'>
                                                <li><Link to='tel:+1 786 789 0606' className='d-flex gap-15'><FaMobileScreenButton /> +1 786 789 0606</Link></li>
                                                <li><Link to='mailto:miami@luminicos.com' className='d-flex gap-15'><FaEnvelope /> miami@luminicos.com</Link></li>
                                                <li><Link to='' className='d-flex gap-15'><FaLocationDot className='location' /> 2125 Biscayne Blvd Suite 242 Miami, FL 33137 USA</Link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
};

export default ContactUs;